import React, { useEffect, useRef, useState } from 'react';
import styles from './UIGameEnd.module.scss';
import { UIGameEndProvider, useUIGameEndContext } from '../../contexts/UIGameEndContext.tsx';
import { UIGameEndHeader } from './UIGameEndHeader/index.ts';
import { UIGameEndContent } from './UIGameEndContent/index.ts';
import { UIGameEndFooter } from './UIGameEndFooter/index.ts';
import { UIGameEndRankedScreen } from './UIGameEndRankedScreen/index.ts';
import Confetti from 'react-confetti';
import { AudioManager, AudioType } from '@colonist/audio';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
export const UIGameEnd = ()=>{
    const isVisible = useGameStore((state)=>state.gameEnd.isVisible);
    const providerProps = useGameStore((state)=>state.gameEnd.providerProps);
    const numberOfPlayersJoinedRematch = useGameStore((state)=>state.gameEnd.numberOfPlayersJoinedRematch);
    const hasShownAnimationsRef = useRef(false);
    if (!providerProps) return null;
    if (!isVisible) return null;
    const isAnimationsDisabled = hasShownAnimationsRef.current;
    if (isVisible) hasShownAnimationsRef.current = true;
    return /*#__PURE__*/ React.createElement(UIGameEndProvider, {
        ...providerProps,
        numberOfPlayersJoinedRematch: numberOfPlayersJoinedRematch
    }, /*#__PURE__*/ React.createElement(UIGameEndComponent, {
        defaultDisableAnimation: isAnimationsDisabled
    }));
};
export function UIGameEndComponent({ defaultDisableAnimation }) {
    const isReplay = useIsReplay();
    const gameEndedCallback = useGameStore((state)=>state.gameEnd.gameEndedCallback);
    const { isPlayerHasRankedState, isMyColorWinner } = useUIGameEndContext();
    const onClickShareGameResults = useGameStore((state)=>{
        var _state_gameEnd_endControls;
        return (_state_gameEnd_endControls = state.gameEnd.endControls) === null || _state_gameEnd_endControls === void 0 ? void 0 : _state_gameEnd_endControls.onClickShareGameResults;
    });
    const shareGameResults = onClickShareGameResults !== null && onClickShareGameResults !== void 0 ? onClickShareGameResults : ()=>undefined;
    const [showRankedScreen, setShowRankedScreen] = useState(isPlayerHasRankedState && !isReplay);
    const [runConfetti, setRunConfetti] = useState(false);
    const safeAreaTop = useGameStore((state)=>state.gameClientConfig.safeAreaInsetTop);
    const disableAnimation = defaultDisableAnimation || isReplay || !isMyColorWinner;
    const playVictorySound = ()=>{
        // Original issue: https://github.com/colonistio/katan/pull/9949
        // TODO Eventually replace the victory sound with the end game music and play for all players
        // Sound.playSound(Sound.SoundType.MusicEgoSum)
        if (!isMyColorWinner) return;
        if (isReplay) return;
        AudioManager.play(AudioType.Victory);
    };
    useEffect(()=>{
        if (!disableAnimation) {
            setRunConfetti(true);
            playVictorySound();
        }
        gameEndedCallback();
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        style: {
            paddingTop: Math.max(safeAreaTop !== null && safeAreaTop !== void 0 ? safeAreaTop : 0, 24)
        }
    }, isMyColorWinner && !isReplay && runConfetti && /*#__PURE__*/ React.createElement(Confetti, {
        className: styles.confetti,
        initialVelocityY: -10,
        numberOfPieces: 175,
        recycle: false
    }), /*#__PURE__*/ React.createElement(UIGameEndHeader, {
        disableAnimation: disableAnimation,
        onClickShareGameResults: shareGameResults
    }), showRankedScreen ? /*#__PURE__*/ React.createElement(UIGameEndRankedScreen, {
        disableAnimation: disableAnimation,
        onContinue: ()=>{
            setShowRankedScreen(false);
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UIGameEndContent, {
        disableAnimation: disableAnimation
    }), /*#__PURE__*/ React.createElement(UIGameEndFooter, {
        disableAnimation: disableAnimation
    })));
}
